import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SearchListType } from 'src/app/@store/search/search.model';

@Pipe({
  name: 'translateSearchListType',
})
export class TranslateSearchListTypePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(useCaseType: SearchListType): string {
    switch (useCaseType) {
      case SearchListType.Gateway:
        return `${this.translateService.instant('+EVENT_LOG.FILTERS.GROUP.COMMUNICATION_MODULE')}`;
      case SearchListType.Boiler:
        return `${this.translateService.instant('+VOUCHERS.BOILER_SERIAL')}`;
      case SearchListType.Error:
        return `${this.translateService.instant('+SEARCH.SEARCH_BY_ERROR.TITLE')}`;
      case SearchListType.User:
        return `${this.translateService.instant('+EVENT_LOG.USER_DESCRIPTION.UNKNOWN_USER')}`;
      default:
        return useCaseType;
    }
  }
}
